import { useEffect, useState } from 'react';

/** Returns a debounced copy of `value` after `delay` ms of inactivity.
 *  Used by every search box so we don't fire an API call per keystroke. */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
